import type { GradeCode } from '@/api/learnerProfile'

type TFn = (key: string, vars?: Record<string, unknown>) => string

export function formatGrade(code: GradeCode | null, t: TFn): string {
  if (code == null) return t('profile.profile.field.gradeEmpty')
  return t(`profile.profile.field.gradeValue.${code}`)
}
